import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import {
  COMPANY,
  HERO_SLIDES,
  FEATURES,
  SERVICES,
  PRODUCTS,
  PRINCIPLES,
  NAV_LINKS,
} from "../data/mock";

const FALLBACK = {
  company: COMPANY,
  heroSlides: HERO_SLIDES,
  features: FEATURES,
  services: SERVICES,
  products: PRODUCTS,
  principles: PRINCIPLES,
  navLinks: NAV_LINKS,
};

const ContentContext = createContext({ content: FALLBACK, loading: true, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/content");
      // Merge so missing keys keep fallback (safety)
      setContent({ ...FALLBACK, ...res.data });
    } catch (e) {
      // Keep fallback silently
      console.warn("Content fetch failed, using fallback.", e?.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh, setContent }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
